// AUTO-PAY FIRST-CARD SIGN-UP — the single source of client-facing copy.
//
// ===========================================================================
// WHY THIS FILE EXISTS (owner bug, 2026-07-18 — money-critical)
// ===========================================================================
// Owner: "At auto pay checkout it should say the booking amount won't be
// charged now, just 1 AED — it shouldn't charge 331 AED the full booking
// price, just the amount which is required to save the card."
//
// A client who picks "pay when the cleaning is completed" but has no token on
// file yet has to hand us a card before auto-charge can be staged. That path
// captures NOTHING: it places a temporary AED 1.00 authorisation hold that the
// backend releases (voids) automatically — no charge, no wallet row — and the
// booking itself is charged after completion, exactly like a client who
// already had a card. The mobile app previously sent this client through the
// ordinary booking card checkout and captured the whole booking total up
// front, which is the defect being fixed.
//
// Every string below is exported rather than inlined so that the web modal and
// the mobile sheet describe the flow IDENTICALLY (P2). The mobile app cannot
// import from the portal bundle, so its copy module mirrors this file
// verbatim — if you change a string here, change it there in the same commit:
//   HHCMobileApp/hhc-mobile-app/constants/autoPaySetupCopy.ts
//
// THE AMOUNT IS A LITERAL. AUTOPAY_SETUP_AMOUNT is the constant 1, never
// derived from an estimate, and the button label binds to it directly. It must
// be impossible for that label to render a booking figure.
// ===========================================================================

export const AUTOPAY_SETUP_AMOUNT = 1;

// Formatted here (not by a caller's money()) so the figure in the button is
// literally this string on both surfaces.
export const AUTOPAY_SETUP_AMOUNT_LABEL = 'AED 1.00';

// The headline note. Takes the FORMATTED booking total purely so the client
// can see which number is NOT being taken — it is never captured.
export const autoPaySetupHeadline = (formattedBookingTotal) =>
    `We will NOT charge the ${formattedBookingTotal} booking amount now.`;

export const AUTOPAY_SETUP_BODY =
    'To set up automatic payments we place a temporary AED 1.00 hold on your card to verify it — the hold is released automatically and is never charged. Your booking is charged only after the cleaning is completed, and we tell you first if the price changed.';

export const AUTOPAY_SETUP_ROW_BOOKING = 'Booking total (charged after completion)';
export const AUTOPAY_SETUP_ROW_VERIFICATION = 'Temporary card hold today (released automatically)';

export const AUTOPAY_SETUP_BUTTON = 'Save card — temporary AED 1.00 hold';

// PENDING INVOICES (owner rule 2026-07-17 vs. this path — stated, never
// silent). The mandatory pending-invoice settlement was written for a checkout
// that captures BOOKING money now. An AED 1.00 verification hold is not a
// booking payment (it captures nothing at all), and the saved-card auto-charge
// path already leaves pending invoices completely untouched. Rolling P into
// this rail would make the client see a figure that is not the one the option
// promised — the exact failure being fixed. So the invoices stay due, the path
// is NOT blocked, and the client is told plainly.
export const autoPaySetupPendingNote = (formattedPendingTotal) =>
    `Your ${formattedPendingTotal} in pending invoices are not included and stay due — settle them from Invoices.`;

// Post-return confirmation, once the card verification has succeeded. The
// backend reports success only after the verify-after-void teardown confirmed
// the hold was released, so "will not be charged" is verified, not assumed.
export const autoPaySetupSuccessBody = (formattedBookingTotal) =>
    `Card saved. Your booking is requested — ${formattedBookingTotal} will be charged to this card only after the cleaning is completed. The temporary AED 1.00 hold is released automatically — you will not be charged for it.`;
